// extracted by mini-css-extract-plugin
module.exports = {"root":"OperationsOverTimespanSelection_root__3RBFt","spaceTop":"OperationsOverTimespanSelection_spaceTop__36E7i"};